import React, { FunctionComponent } from 'react'
import { T } from '@transifex/react'
import { ERRORS } from '../../../../constants'
import { useAppSelector } from '../../../../state/hooks'
import { selectLineItemPriceInputError } from '../../../../state/slices/uiStateSlice'
import { InputErrorMessage } from './InputErrorMessage'

interface Props {
  lineItemID: string
}

export const LineItemPriceError: FunctionComponent<Props> = ({
  lineItemID,
}) => {
  const lineItemPriceError = useAppSelector(
    selectLineItemPriceInputError(lineItemID)
  )

  let errorElement: React.JSX.Element | null = null

  if (lineItemPriceError === ERRORS.INVALID_DISCOUNT) {
    errorElement = <T _str="Price is lower than the minimum allowed" />
  }

  if (lineItemPriceError === ERRORS.INVALID_CHARACTERS) {
    errorElement = (
      <T
        _str="Enter a positive number"
        _context="Error message when the input is negative or contains non-numeric characters"
      />
    )
  }

  if (lineItemPriceError === ERRORS.INVALID_MAX) {
    errorElement = (
      <T
        _str="Amount must be less than $10,000,000,000.00"
        _context="Error message when the input value is over the maximum allowed"
      />
    )
  }

  return errorElement ? <InputErrorMessage errorElement={errorElement} /> : null
}
